import plsql from "refractor/plsql";
export default plsql;